// Global Instructions Rule Applied!

export const SET_CAMPAIGNS = 'email/SET_CAMPAIGNS' as const
export const SET_ACTIVE_FILTERS = 'email/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'email/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'email/CLEAR_ACTIVE_FILTERS' as const
export const ADD_CAMPAIGN = 'email/ADD_CAMPAIGN' as const
export const UPDATE_CAMPAIGN_RECORD = 'email/UPDATE_CAMPAIGN_RECORD' as const
export const REMOVE_CAMPAIGN = 'email/REMOVE_CAMPAIGN' as const
